import type { TFunction } from "i18next";

import type { ActiveFilter } from "@/components/ui/v2/table/table-active-filters";

export function buildChangeTypeFilters(
  selected: string[],
  t: TFunction,
): ActiveFilter[] {
  return selected.map((type) => ({
    key: "changeType",
    label: t("admin.segments.history.changeTypeFilter"),
    value: type,
    valueLabel: t(`admin.segments.history.changeTypes.${type}`, {
      defaultValue: type,
    }),
  }));
}
